
class previewTemplateCtrl {
    constructor($scope, $uibModalInstance, obj, httpRequest) {
        // console.log(obj);
        if (obj.state === 'add/edit') {
            $scope.resObj = obj.resObj
            console.log(obj)
        } else {
            const reqObj = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    bizName: obj.bizName,
                    bizType: obj.bizType,
                    endTime: '',
                    orgId: '',
                    startTime: '',
                    status: obj.status,
                    templateId: obj.templateId,
                },
            }
            httpRequest.post_getContractTemplateList(reqObj).then((res) => {
                $scope.resObj = res.data.value.list[0]
            })
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
    }
}

previewTemplateCtrl.$inject = ['$scope', '$uibModalInstance', 'obj', 'httpRequest']
export default previewTemplateCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetUp/previewTemplateCtrl.js